module.exports = __webpack_public_path__ + "assets/img/r3.c727656a.png";